export var UrlScheme = /*#__PURE__*/ function(UrlScheme) {
    UrlScheme["File"] = "file:";
    UrlScheme["Http"] = "http:";
    UrlScheme["Https"] = "https:";
    return UrlScheme;
}({});

//# sourceMappingURL=video-platforms.enums.js.map